export enum raptorMapsConstants {
  RAPTOR_MAPS_DOMAIN = 'raptormaps.com',
}
